import Vue from 'vue';
import Notification from 'components/notification/Notification.vue';
import {
    generateId,
    prepareContainer
} from 'services/overlayService/OverlayService';

export const notifications = new Map();
const NOTIFICATION_TIMEOUT = 5000;
const ANIMATION_TIME_MS = 600;

Vue.use({
    install(v) {
        // eslint-disable-next-line no-param-reassign
        v.prototype.$notification = {
            open({
                type,
                body,
                container,
                id = generateId()
            }) {
                const scope = this;
                const { vueContainer } = prepareContainer(container);

                const closeNotification = (notification) => {
                    // eslint-disable-next-line no-param-reassign
                    notification.open = false;
                    setTimeout(() => {
                        scope.close();
                    }, ANIMATION_TIME_MS);
                };

                const notification = new Vue({
                    el: vueContainer.firstChild,
                    data() {
                        return {
                            type,
                            body,
                            id,
                            open: false,
                            timeout: null
                        };
                    },
                    render(createElement) {
                        return createElement(Notification, {
                            tag: 'component',
                            attrs: {
                                id: this.id,
                                type: this.type,
                                body: this.body,
                                open: this.open
                            },
                            on: {
                                cancel: this.close
                            }
                        });
                    },
                    mounted() {
                        if (this.type !== 'error') {
                            this.timeout = setTimeout(() => {
                                this.close();
                            }, NOTIFICATION_TIMEOUT);
                        }
                    },
                    methods: {
                        close() {
                            clearTimeout(this.timeout);
                            closeNotification(this);
                        }
                    }
                });

                notification.$nextTick(() => { notification.open = true; });

                // add the notification to the notifications map so it can be accessed with it's id
                notifications.set(id, {
                    notification,
                    vueContainer
                });

                return id;
            },
            close(id) {
                let notificationToRemove;
                let notificationId = id;

                // if an id was provided, get the notification by id, if not, get the last opened notification
                if (notificationId) {
                    notificationToRemove = notifications.get(id);
                } else {
                    const lastOpenNotification = [...notifications].pop();
                    [notificationId, notificationToRemove] = lastOpenNotification;
                }

                if (notificationToRemove) {
                    notifications.delete(notificationId);

                    const {
                        notification,
                        vueContainer
                    } = notificationToRemove;

                    notification.$destroy();
                    notification.$el.remove();
                    vueContainer.remove();
                }
            }
        };
    }
});
